import React from 'react';
import { formatCompanyDateTime } from '../utils/companyDateFormat';
import type { ScheduleShiftImportBatchRowResult } from '../types';

function fmt(dt: string | null | undefined): string {
  if (!dt) return '—';
  return formatCompanyDateTime(dt) || dt;
}

function statusClass(status: string): string {
  switch (status) {
    case 'Valid':
      return 'text-green-700';
    case 'Overlap':
      return 'text-amber-800 font-medium';
    case 'Holiday':
      return 'text-green-800 font-medium';
    case 'Imported':
      return 'text-blue-700';
    case 'Skipped':
      return 'text-gray-600';
    case 'Deleted':
      return 'text-gray-600';
    default:
      return 'text-red-700';
  }
}

function rowBg(status: string): string {
  if (status === 'Overlap') return 'bg-amber-50/90';
  if (status === 'Holiday') return 'bg-green-50/90';
  if (status === 'Valid') return 'bg-white';
  return '';
}

export function ScheduleShiftImportRowsPreviewTable({ rows }: { rows: ScheduleShiftImportBatchRowResult[] }) {
  return (
    <div className="overflow-x-auto rounded border border-gray-200">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-2 py-2 text-left font-medium text-gray-700">Row</th>
            <th className="px-2 py-2 text-left font-medium text-gray-700">Name</th>
            <th className="px-2 py-2 text-left font-medium text-gray-700">Start</th>
            <th className="px-2 py-2 text-left font-medium text-gray-700">End</th>
            <th className="px-2 py-2 text-left font-medium text-gray-700">Status</th>
            <th className="px-2 py-2 text-left font-medium text-gray-700">Details</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className={`border-t border-gray-100 ${rowBg(r.status)}`}>
              <td className="px-2 py-1.5">{r.excelRowNumber}</td>
              <td className="px-2 py-1.5">
                {r.employeeNameRaw ?? '—'}
                {r.createsPlaceholder ? (
                  <span className="ml-1 text-xs text-blue-700">New placeholder</span>
                ) : r.resolvedPlaceholderId ? (
                  <span className="ml-1 text-xs text-gray-500">Placeholder</span>
                ) : null}
              </td>
              <td className="px-2 py-1.5 whitespace-nowrap">{fmt(r.shiftStart)}</td>
              <td className="px-2 py-1.5 whitespace-nowrap">{fmt(r.shiftEnd)}</td>
              <td className="px-2 py-1.5">
                <span className={statusClass(r.status)}>{r.status}</span>
              </td>
              <td className="px-2 py-1.5 text-gray-600 max-w-md" title={r.errorMessage ?? undefined}>
                <span className="line-clamp-3">{r.errorMessage ?? '—'}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
